module.exports = __webpack_public_path__ + "img/2018广东推介会.8a272209.jpg";